var map = {
	"./Mensingles.png": "b820",
	"./add-player-icon.png": "7623",
	"./badminton_1.png": "f569",
	"./badminton_2.png": "8801",
	"./badminton_25.png": "0bbf",
	"./badminton_26.png": "0c53",
	"./badminton_27.png": "abc8",
	"./badminton_3.png": "cb9f",
	"./badminton_4.png": "3957",
	"./badminton_5.png": "4190",
	"./badminton_6.png": "88a0",
	"./badminton_7.png": "394d",
	"./badminton_8.png": "71a6",
	"./basket_1 copy.png": "5c77",
	"./basket_1.png": "d884",
	"./basket_2 copy.png": "e5d4",
	"./basket_2.png": "b98e",
	"./basket_25 copy.png": "a104",
	"./basket_25.png": "b675",
	"./basket_26 copy.png": "9845",
	"./basket_26.png": "da00",
	"./basket_27 copy.png": "4cff",
	"./basket_27.png": "07e5",
	"./basket_3 copy.png": "ed82",
	"./basket_3.png": "4617",
	"./basket_4 copy.png": "81ca",
	"./basket_4.png": "70d2",
	"./basket_5 copy.png": "9cf3",
	"./basket_5.png": "236e",
	"./basket_6 copy.png": "3938",
	"./basket_6.png": "c08f",
	"./basket_7 copy.png": "018d",
	"./basket_7.png": "6af2",
	"./basket_8 copy.png": "0d36",
	"./basket_8.png": "7289",
	"./delete-icon.png": "a65a",
	"./detail_livelist_playicon.png": "8f73",
	"./game_icon_assist.png": "ef56",
	"./game_icon_down.png": "4ad7",
	"./game_icon_goal.png": "82f2",
	"./game_icon_ownGoal.png": "0a55",
	"./game_icon_penalty.png": "6c5a",
	"./game_icon_red.png": "4e31",
	"./game_icon_score.png": "0240",
	"./game_icon_up.png": "3b37",
	"./game_icon_yellow.png": "d2e0",
	"./insurance-icon.png": "1bda",
	"./list_arrow.png": "6b56",
	"./match_icon_play.png": "c699",
	"./match_info.png": "f09e",
	"./match_record_left.png": "013e",
	"./match_record_right.png": "7adb",
	"./match_stats_02.png": "25cb",
	"./playerrank.png": "09bf",
	"./qy_0.png": "d0ea",
	"./qy_1.png": "238b",
	"./qy_10.png": "c0f2",
	"./qy_11.png": "8b69",
	"./qy_12.png": "3512",
	"./qy_13.png": "bd87",
	"./qy_14.png": "c4de",
	"./qy_15.png": "db7c",
	"./qy_16.png": "7572",
	"./qy_17.png": "04f1",
	"./qy_18.png": "1056",
	"./qy_19.png": "10af",
	"./qy_2.png": "914a",
	"./qy_20.png": "ccd7",
	"./qy_21.png": "173a",
	"./qy_22.png": "ae8f",
	"./qy_23.png": "244a",
	"./qy_24.png": "a32a",
	"./qy_25.png": "8752",
	"./qy_26.png": "cc38",
	"./qy_27.png": "a443",
	"./qy_3.png": "06d5",
	"./qy_4.png": "cff4",
	"./qy_5.png": "13c9",
	"./qy_6.png": "6da3",
	"./qy_7.png": "04c6",
	"./qy_8.png": "e1bc",
	"./qy_9.png": "282e",
	"./rankOne.png": "597f",
	"./rankingThree.png": "7acb",
	"./rankingtwo.png": "4eb7",
	"./shoufa.png": "2bf0",
	"./success-icon.png": "2ee1",
	"./success-icon2.png": "e271",
	"./teamNo1.png": "b91a",
	"./vip-banner.png": "8d22",
	"./wx-icon.png": "f278",
	"./wx-round-icon.png": "64e6"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "e078";